import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();
  return (
    <Container className="d-flex min-vh-100 align-items-center justify-content-center">
      <Row className="text-center">
        <Col>
          <h1 className="fs-3 fw-semibold text-secondary mt-4 mb-3">
            You're not permitted to access this.
          </h1>
          <p className="mb-2 text-light-emphasis">
            The page you're trying to access has restricted access.
            <br className="d-none d-md-block" /> If you feel this is a mistake,
            contact your admin.
          </p>
          <Button
            variant="secondary"
            className="mt-3"
            onClick={() => navigate("/login")}
          >
            RETURN HOME
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default AccessDenied;
